import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import * as React from 'react'
import './i18n' // import i18n (needs to be bundled ;))
import i18n from './i18n'
const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

// StrictMode Lets us find common bugs in our components early during development (e.g. wrong useEffect usage)
// StrictMode double renders components to help us find bugs, in production don't use it - cause we get wrong analytics values
// https://beta.reactjs.org/reference/react/StrictMode#fixing-bugs-found-by-double-rendering-in-development
root.render(
  // <StrictMode>
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
  // </StrictMode>
)
